import React, { useState, useEffect } from 'react';
import { useProvider, Toast } from '../context/MenuProvider';
import { Button, Form, Table, Card, Alert, InputGroup } from "react-bootstrap";
import { Link } from 'react-router-dom';


const MESES = {
  1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun',
  7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez'
};

const ANOS = (() => {
  const atual = new Date().getFullYear();
  return [atual, atual - 1, atual - 2];
})();

const emptyGerenciaMeta = () => ({
  id: null,
  categoria: null,
  mes: "",
  ano: "",
  is_quantidade: false,
  valor: "",
  alcancado: "",
  progresso: "",
  diario: "",
});

const GerenciarMetas = () => {
  const { crud, hasPerms, setTitle } = useProvider();
  const { get, post } = crud || {};

  const [mesAno, setMesAno] = useState({
    ano: new Date().getFullYear(),
    mes: new Date().getMonth() + 1, // getMonth() retorna 0-11
  });
  const [metas, setMetas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  const updateField = async(i, field, value) => {
    const temp = [...metas];
    temp[i][field] = value;
    setMetas(temp);
    
    const dados = {
        ano: mesAno?.ano,
        mes: mesAno?.mes,
        categoria: temp[i].categoria?.id,
        is_quantidade: !!temp[i].is_quantidade,
        valor: parseFloat(value || 0)
    };
    
    try{
      const response = await post(dados, `/gvendas/metas/`, null, 'updateField');
      if(response && response.length){
        const item = response[0];
        temp[i]['id'] = item.id;
        temp[i]['alcancado'] = item.alcancado??0;
        temp[i]['progresso'] = item.progresso??0;
        temp[i]['diario'] = item.diario??0;
        setMetas(temp);
      }
    }catch(err){
      
    }
  };
  
  setTitle("Metas do Mês")

  useEffect(() => {
    const buscar = async () => {
      try {
        let lista = [];
        if (hasPerms("loja.view_venda")) lista.push("venda", "produtos");
        if (hasPerms("rede.view_apn")) lista.push("rede");
        const tipos = lista.join(",");
        if (!tipos) return;
        const response = await get([
          `/gvendas/categorias/?tipo__in=${tipos}`,
          `/gvendas/metas/?categoria__tipo__in=${tipos}&ano=${mesAno.ano}&mes=${mesAno.mes}&expand=categoria`
        ], 'buscar');

        const categoriasApi = response[0].results;
        const metasApi = response[1].results;

        const faltantes = categoriasApi.filter(cat =>
          !metasApi.some(m => m.categoria?.id === cat.id)
        );

        const novas = faltantes.flatMap(cat => {
          if (cat.tipo === 'rede') {
            return [{
              ...emptyGerenciaMeta(),
              categoria: cat,
              mes: mesAno.mes,
              ano: mesAno.ano,
              is_quantidade: true
            }];
          }
          return [
            {
              ...emptyGerenciaMeta(),
              categoria: cat,
              mes: mesAno.mes,
              ano: mesAno.ano,
              is_quantidade: true
            },
            {
              ...emptyGerenciaMeta(),
              categoria: cat,
              mes: mesAno.mes,
              ano: mesAno.ano,
              is_quantidade: false
            }
          ];
        });

        setCategorias(categoriasApi);
        setMetas([...metasApi, ...novas]);
      } catch (e) {}
    };
    buscar();
  }, [mesAno]);

  return (
    <>
      <InputGroup className="mb-2">
        <span className="input-group-text">Meta</span>
        <Form.Select value={mesAno.mes} onChange={e => setMesAno(p => ({ ...p, mes: e.target.value }))}>
          {Object.entries(MESES).map(([id, nome]) => (
            <option key={id} value={id}>{nome}</option>
          ))}
        </Form.Select>
        <Form.Select value={mesAno.ano} onChange={e => setMesAno(p => ({ ...p, ano: e.target.value }))}>
          {ANOS.map(a => <option key={a} value={a}>{a}</option>)}
        </Form.Select>
      </InputGroup>

      <div className="table-responsive">
        <Table bordered hover size="sm">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Categoria</th>
              <th>Meta</th>
              <th>Alcançado</th>
              <th>Progresso</th>
              <th>Diário</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {metas.map((c, i) => (
              <tr key={i}>
                <td>{MESES[c.mes]}/{c.ano}</td>
                <td>{c.categoria?.nome_da_categoria}</td>
                <td>
                  <InputGroup style={{ width: "100%", flexWrap: "nowrap", whiteSpace: "nowrap" }}>
                    <span className="input-group-text">{c.is_quantidade ? 'Qt' : 'R$'}</span>
                    <Form.Control type="number" value={c.valor}
                      onChange={e => updateField(i, "valor", e.target.value)} 
                      onBlur={e => updateField(i, "valor", c.is_quantidade? Math.ceil(parseFloat(e.target.value || 0)):parseFloat(e.target.value || 0).toFixed(2))} 
                    />
                  </InputGroup>
                </td>
                <td>{c.alcancado !== "" && (<>{c.is_quantidade?Math.ceil(parseFloat(c.alcancado)):parseFloat(c.alcancado).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</>)}</td>
                <td>{c.progresso !== "" && (<>{c.progresso}%</>)}</td>
                <td>{c.diario !== "" && (<>{c.is_quantidade?Math.ceil(parseFloat(c.diario)):parseFloat(c.diario).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</>)}</td>
                <td>
                  {c.id && (<>
                    <InputGroup style={{ width: "100%", flexWrap: "nowrap", whiteSpace: "nowrap" }}>
                      {(c.categoria?.id && c.categoria?.tipo) && (
                        <Button
                          as={Link}
                          to={`/relatorios/${c.categoria?.tipo}/${c.categoria?.id}/balanco/${mesAno?.ano}/`}
                          variant="outline-secondary"
                          className="px-4"
                          size="sm"
                        >
                          <i className="bx bx-columns"></i>
                        </Button>
                      )}
                      {(c.categoria?.id && c.categoria?.tipo) && (
                        <Button
                          as={Link}
                          to={`/relatorios/${c.categoria?.tipo}/${c.categoria?.id}/barras/${mesAno?.ano}/`}
                          variant="outline-secondary"
                          className="px-4"
                          size="sm"
                        >
                          <i className="bx bx-bar-chart"></i>
                        </Button>
                      )}
                      {c.categoria?.tipo && (
                        <Button
                          as={Link}
                          to={`/relatorios/${c.categoria?.tipo}/barras-categorias`}
                          variant="outline-secondary"
                          className="px-4"
                          size="sm"
                        >
                          <i className="bx bx-line-chart"></i>
                        </Button>
                      )}
                    </InputGroup>
                  </>)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default GerenciarMetas;